module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/lizard_BW-p-2000-211b989ef9ff811f287cbc06fa80be7b.jpg";